const translations = {
    ka: {
        global: {
            success_message: "წერილი წარმატებით გაიგზავნა!",
            prices: "ფასები:",
            title: "სათაური",
            description: "აღწერა",
            price: "ფასი",
            action: "ქმედება",
            book: "დაჯავშნა",
            processing: "დაჯავშნილი...",
            confirmed: "გაყიდული!",
            send: "გაგზავნა",
            free: "უფასო",
            lastUpdate: "ბოლოს განახლდა",
        },
        contact: {
            name: "სახელი",
            name_placeholder: "მაგ: ჯონ დოე",
            email: "ელ-ფოსტა",
            email_placeholder: "მაგ: johndoe@mail.com",
            subject: "სათაური",
            subject_placeholder: "მაგ: ლორემ იპსუმ",
            message: "წერილი",
            message_placeholder: "ლორემ იპსუმ დოლორ, სიტ ამეტ...",
            send: "გაგზავნა",
        },
        datatables: {
            per_page: "ჩანაწერი ერთ გვერდზე",
            all_categories: "ყველა კატეგორია",
            all_municipalities: "ყველა მდებარეობა",
            all_villages: "ყველა სოფელი",
            all_services: "ყველა სერვისი",
            download_all: "ყველას გადმოწერა",
            choose_language: "აირჩიეთ ენა",
            georgian: "ქართული",
            english: "ინგლისური",
            russian: "რუსული",
            download: "გადმოწერე",
            record: "ჩანაწერი",
            records: "ჩანაწერი",
            name: "დასახელება",
            category: "კატეგორია",
            municipality: "მდებარეობა",
            village: "სოფელი",
            phone: "ტელეფონი",
            email: "ელ-ფოსტა",
            showing: "ნაჩვენებია",
            from: "დან",
            to: "მდე ჩანაწერი,",
            from_records: "ჩანაწერიდან",
            filters: "ფილტრები",
            search: "ძიება...",
            association: "გადამზადება",
            website_email: "ვებ-საიტი/ელ-ფოსტა",
            address: "მისამართი",
            rooms: "ნომრები",
            beds: "ადგილი",
            cuisine: "სამზარეულო",
            working: "მუშაობს",
            car_release_year: "გამოშვების წელი",
            seats: "ადგილების რაოდენობა",
        },
        error: {
            title: "გვერდი ვერ მოიძებნა",
            text: "გვერდი, რომელსაც ეძებდით, შეიძლება წაიშალა, შეიცავლა სახელი ან დროებით მიუწვდომელია.",
            button: "მთავარზე დაბრუნება",
        },
        validation: {
            error: "გთხოვთ სწორად შეიყვანოთ მონაცემები!",
            required_field: "აუცილებელი ველი.",
            email: "ელ-ფოსტის ფორმატი არასწორია.",
            min5: "მინიმუმ 5 სიმბოლო.",
            min10: "მინიმუმ 10 სიმბოლო.",
            min20: "მინიმუმ 20 სიმბოლო.",
            phone: "ნომერი უნდა შედგებოდეს 9 ციფრისგან.",
            id: "დასაშვებია მხოლოდ 9/11 ნიშნა საიდენტიფიკაციო/პირადი ნომერი.",
            file_size:
                "ფოტოების ზომა აღემატება დაშვებულს. დასაშვებია მაქსიმუმ 1მბ - 1 ფოტოს ზომა",
            products:
                "გამოფენაზე გამოსატანი პროდუქციის ველი უნდა შედგებოდეს მინიმუმ 10 სიმბოლოსგან.",
        },
        tour_form: {
            name: "სახელი და გვარი",
            name_placeholder: "მაგ: გიორგი ბერიძე",
            email: "ელ-ფოსტა",
            email_placeholder: "მაგ: giorgiberidze@gmail.com",
            phone: "ტელეფონი",
            phone_placeholder: "მაგ: 577223344",
            agency: "სააგენტოს დასახელება",
            agency_placeholder: "მაგ: ვანდერლენდი",
            button: "რეგისტრაცია",
            success_message: "თქვენ წარმატებით გაიარეთ რეგისტრაცია!",
            not_allowed_message: "რეგისტრაციის ლიმიტი ამოიწურა!",
            already_registered: "თქვენ უკვე რეგისტრირებული ხართ!",
            products: "გამოფენაზე გამოსატანი პროდუქციის აღწერა",
            confirm_button: "გამორთვა",
        },
        booking: {
            company_name: "კომპანიის დასახელება",
            company_name_placeholder: "მაგ: სასტუმრო ადმირალი",
            company_id: "კომპანიის ს/კ",
            company_id_placeholder: "მაგ: 123456789",
            company_director: "კომპანიის დირექტორი",
            company_director_placeholder: "მაგ: ნიკა ბოლქვაძე",
            contact_person: "საკონტაქტო პირი",
            contact_person_placeholder: "მაგ: გიორგი ბერიძე",
            success_message: "წარმატებით დაიჯავშნა!",
        },
        good_host: {
            company_type: "კომპანიის ტიპი",
            choose_company_type: "აირჩიეთ კომპანიის ტიპი",
            accommodation: "საოჯახო სასტუმრო",
            food: "კვების ობიექტი",
            select_question: "კრიტერიუმის დაკმაყოფილება",
            relevant: "რელევანტურობა",
            comment: "კომენტარი",
            required: "სავალდებულო",
            recommended: "რეკომენდებული",
            add_comment: "კომენტარის დამატება",
            company_name: "კომპანიის სახელი",
            contact_person: "საკონტაქტო პირი",
            website: "ვებ-საიტი",
            link: "ბმული",
            check_minimum_one_question:
                "გთხოვთ მონიშნოთ მინიმუმ ერთი კრიტერიუმი!",
            success_text:
                "განვიხილავთ თქვენს მოთხოვნას და უახლოეს მომავალში დაგიკავშირდებით.",
            close: "დახურვა",
            remove_comment: "კომენტარის წაშლა",
        },
        new_record: {
            add_new_record: "ჩანაწერის დამატება",
            main_information: "ძირითადი ინფორმაცია",
            category: "კატეგორია",
            city_municipality: "მდებარეობა",
            village: "სოფელი",
            title: "დასახელება",
            contact_information: "საკონტაქტო ინფორმაცია",
            street: "ქუჩა",
            address: "მისამართი",
            additional_information: "დამატებითი ინფორმაცია",
            stars: "ვარსკვლავი",
            rooms: "ოთახი",
            beds: "საწოლი",
            check_in: "ჩექინი",
            check_out: "ჩექაუთი",
            price_from: "ფასი (დან)",
            price_to: "ფასი (მდე)",
            services: "სერვისი",
            seasons: "სეზონი",
            adapted_room: "შშმ ადაპტირებული ოთახი",
            quantity: "რაოდენობა",
            president_suite_room: "საპრეზიდენტო ნომერი",
            open_year: "გახსნის წელი",
            lat: "გრძედი",
            long: "განედი",
            media: "მედია",
            image: "ფოტო",
            new_record: "დამატება",
            add_message:
                "თქვენი მოთხოვნა მიღებულია. გთხოვთ, დაელოდოთ ჩვენს დასტურს.",
            director: "დირექტორი",
            director_phone: "დირექტორის მობილური",
            manager: "მენეჯერი",
            manager_phone: "მენეჯერის მობილური",
            cuisines: "სამზარეულო",
            wines: "ღვინის სახეობები",
            live_music: "ცოცხალი მუსიკა",
            lunch_menu: "ლანჩ მენიუ",
            pandus: "პანდუსი",
            seats: "ადგილების რაოდენობა",
            hours_from: "სამუშაო საათები (დან)",
            hours_to: "სამუშაო საათები (მდე)",
            countries: "ქვეყნები",
            full_name: "სახელი და გვარი",
            birth_year: "დაბადების წელი",
            experience: "გამოცდილება (წელი)",
            certified: "სერტიფიცირებული",
            languages: "ენები",
            associations: "ასოციაცია / გადამზადება",
            registration: "რეგისტრაცია",
            your_status: "თქვენი სტატუსი",
            physical_person: "ფიზიკური პირი",
            juridical_person: "იურიდიული პირი",
        },
        url_shortener: {
            shorten: "დამოკლება",
            copied: "კოპირებულია",
            copy: "კოპირება",
        },
        qr_generator: {
            generate: "დაგენერირება",
            download: "გადმოწერა",
        },
        hiking_festival: {
            birthday: "დაბადების თარიღი (რიცხვი/თვე/წელი)",
            country: "ქვეყანა",
            city: "ქალაქი",
            passport: "პასპორტი ან პირადობის მოწმობა (ორივე მხარე, მაქს. 5მბ)",
            where_did_you_find_us:
                "საიდან მიიღეთ ინფორმაცია ღონისძიების შესახებ?",
            about: "გაგვიზიარე მცირე ინფორმაცია თქვენ შესახებ",
            gets_medicaments: "ღებულობთ თუ არა მედიკამენტებს?",
            registration_success:
                "თქვენ წარმატებით გაიარეთ სალაშქრო ფესტივალზე რეგისტრაცია. უახლოეს მომავალში დაგიკავშირდებით.",
            yes: "დიახ",
            no: "არა",
            file_size_limit: "ფაილის ზომა აღემატება დაშვებულს.",
            has_hiking_experience:
                "გაქვთ თუ არა მაღალმთიან მარშრუტებზე ლაშქრობის გამოცდილება?",
            has_hiking_equipments:
                "ფლობთ თუ არა ხანგრძლივ მარშრუტებზე მოგზაურობისთვის საჭირო სალაშქრო აღჭურვილობას?",
            is_with_partner:
                "აღნიშნულ ფესტივალზე მეწყვილესთან ერთად ღებულობთ მონაწილეობას?",
            partner_name: "მეწყვილის სახელი და გვარი",
            distance_while_hiking:
                "რამდენი კილომეტრი გაქვთ გავლილი მაღალმთიან მარშრუტზე მოგზაურობის დროს ერთი დღის განმავლობაში?",
            choose: "აირჩიეთ ერთ-ერთი",
            friend: "მეგობრისგან",
            social: "Facebook ან სხვა სოც. ქსელიდან",
            google: "Google ან სხვა საძიებო სისტემიდან",
            other: "სხვა",
            current_city: "დროებითი ან მუდმივი საცხოვრებელი ადგილი (ქალაქი)",
        },
    },
    en: {
        global: {
            success_message: "Message sent successfully!",
            prices: "Prices:",
            title: "Title",
            description: "Description",
            price: "Price",
            action: "Action",
            book: "Book",
            processing: "Processing...",
            confirmed: "Sold!",
            send: "Send",
            free: "Free",
            lastUpdate: "Last update",
        },
        contact: {
            name: "Name",
            name_placeholder: "Ex: John Doe",
            email: "Email",
            email_placeholder: "Ex: johndoe@mail.com",
            subject: "Subject",
            subject_placeholder: "Ex: Lorem ipsum",
            message: "Message",
            message_placeholder: "Lorem ipsum dolor, sit amet...",
            send: "Send",
        },
        datatables: {
            per_page: "records per page",
            all_categories: "All categories",
            all_municipalities: "All municipalities",
            all_villages: "All villages",
            all_services: "All services",
            download_all: "Download all",
            choose_language: "Choose language",
            georgian: "Georgian",
            english: "English",
            russian: "Russian",
            download: "Download",
            record: "record",
            records: "records",
            name: "Title",
            category: "Category",
            municipality: "Municipality",
            village: "Village",
            phone: "Phone",
            email: "Email",
            showing: "Showing",
            from: "to",
            to: "of",
            from_records: "records",
            filters: "Filters",
            search: "Search...",
            association: "Training",
            website_email: "Website/Email",
            address: "Address",
            rooms: "Rooms",
            beds: "Beds",
            cuisine: "Cuisine",
            working: "Working",
            car_release_year: "Release year",
            seats: "Car seats",
        },
        error: {
            title: "Page not found",
            text: "The page you are looking for, might have been removed, had its name changed or is temporarily unavailable.",
            button: "Back to Homepage",
        },
        validation: {
            error: "Fill in all the data correctly!",
            required_field: "Required field.",
            email: "Enter the correct email.",
            min5: "Minimum 5 symbols.",
            min10: "Minimum 10 symbols.",
            min20: "Minimum 20 symbols.",
            phone: "The number should contain 9 digits.",
            id: "Allowed 9/11 digits for ID.",
            file_size:
                "The file size for these images exceeds our limits. You can upload a maximum of 1MB per file",
            products: "Minimum 10 symbols are required.",
        },
        tour_form: {
            name: "Full name",
            name_placeholder: "Ex: Giorgi Beridze",
            email: "Email",
            email_placeholder: "Ex: giorgiberidze@gmail.com",
            phone: "Phone",
            phone_placeholder: "Ex: 577223344",
            agency: "Agency name",
            agency_placeholder: "Ex: wOnderland",
            button: "Register",
            success_message: "You have successfully registered!",
            not_allowed_message: "The registration limit is over!",
            already_registered: "You are already registered!",
            products: "Products for exhibition",
            confirm_button: "Close",
        },
        booking: {
            company_name: "Company name",
            company_name_placeholder: "Ex: Hotel Admiral",
            company_id: "Company ID",
            company_id_placeholder: "Ex: 123456789",
            company_director: "Company director",
            company_director_placeholder: "Ex: Nika Bolkvadze",
            contact_person: "Contact person name",
            contact_person_placeholder: "Ex: Giorgi Beridze",
            success_message: "Booked successfully!",
        },
        good_host: {
            company_type: "Company type",
            choose_company_type: "Choose company type",
            accommodation: "Guest house",
            food: "Restaurant",
            select_question: "Check related",
            relevant: "Relevant",
            comment: "Comment",
            required: "Required",
            recommended: "Recommended",
            add_comment: "Add comment",
            company_name: "Company name",
            contact_person: "Contact person",
            website: "Website",
            link: "URL",
            check_minimum_one_question: "Please check minimum one question!",
            success_text:
                "We will check your application and contact you soon.",
            close: "Close",
            remove_comment: "Remove comment",
        },
        new_record: {
            add_new_record: "Add new record",
            main_information: "Main information",
            category: "Category",
            city_municipality: "City/municipality",
            village: "Village",
            title: "Name",
            contact_information: "Contact information",
            street: "Street",
            address: "Address",
            additional_information: "Additional information",
            stars: "Stars",
            rooms: "Rooms",
            beds: "Beds",
            check_in: "Check-in",
            check_out: "Check-out",
            price_from: "Price (from)",
            price_to: "Price (to)",
            services: "Services",
            seasons: "Seasons",
            adapted_room: "Adapted rooms",
            quantity: "Quantity",
            president_suite_room: "President suite rooms",
            open_year: "Open year",
            lat: "Latitude",
            long: "Longitude",
            media: "Media",
            image: "Image",
            new_record: "New record",
            add_message:
                "We received your request. Please wait our confirmation message.",
            director: "Director",
            director_phone: "Director phone",
            manager: "Manager",
            manager_phone: "Manager phone",
            cuisines: "Cuisine",
            wines: "Wine species",
            live_music: "Live music",
            lunch_menu: "Lunch menu",
            pandus: "Pandus",
            seats: "Seats",
            hours_from: "Working hours (from)",
            hours_to: "Working hours (to)",
            countries: "Countries",
            full_name: "Full name",
            birth_year: "Birth year",
            experience: "Experience (year)",
            certified: "Certified",
            languages: "Languages",
            associations: "Association / training",
            registration: "Registration",
            your_status: "Your status",
            physical_person: "Individual",
            juridical_person: "Entity",
        },
        url_shortener: {
            shorten: "Shorten",
            copied: "Copied",
            copy: "Copy",
        },
        qr_generator: {
            generate: "Generate",
            download: "Download",
        },
        hiking_festival: {
            birthday: "Birthday (Day/Month/Year)",
            country: "Country",
            city: "City",
            passport: "Passport or ID (Both sides, Max. 5MB)",
            where_did_you_find_us: "How did you learn about this event?",
            about: "About you",
            gets_medicaments: "Do you take any medications?",
            registration_success:
                "You have been registered successfully. We will get back to you soon.",
            yes: "Yes",
            no: "No",
            file_size_limit: "File size too big.",
            has_hiking_experience:
                "Do you have hiking experience in the mountains?",
            has_hiking_equipments:
                "Do you have all the necessary equipment for hiking?",
            is_with_partner:
                "Do you plan to participate in this festival with your partner?",
            partner_name: "Partner's full name",
            distance_while_hiking:
                "How many kilometers have you walked while hiking in the mountains?",
            choose: "Choose one",
            friend: "Friend told me",
            social: "Facebook or other social network",
            google: "Google or other search engine",
            other: "Other",
            current_city: "Temporary or permanent place of residence (City)",
        },
    },
    ru: {
        global: {
            success_message: "Сообщение успешно отправлено!",
            prices: "Цены:",
            title: "Название",
            description: "Описание",
            price: "Цена",
            action: "Действие",
            book: "Заказать",
            processing: "Обработка...",
            confirmed: "Продано!",
            send: "Отправить",
            free: "Бесплатно",
            lastUpdate: "Последнее обновление",
        },
        contact: {
            name: "Имя",
            name_placeholder: "Пр: Джон Доу",
            email: "Эл. адрес",
            email_placeholder: "Пр: johndoe@mail.com",
            subject: "Тема",
            subject_placeholder: "Пр: Лорем ипсум",
            message: "Сообщение",
            message_placeholder: "Лорем ипсум долор, сит амет...",
            send: "Отправить",
        },
        datatables: {
            per_page: "записей на странице",
            all_categories: "Все категории",
            all_municipalities: "Все муниципалитеты",
            all_villages: "Все деревни",
            all_services: "Все услуги",
            download_all: "Скачать все",
            choose_language: "Выберите язык",
            georgian: "Грузинский",
            english: "Английский",
            russian: "Русский",
            download: "Скачать",
            record: "запись",
            records: "записей",
            name: "Название",
            category: "Категория",
            municipality: "Муниципалитет",
            village: "Деревня",
            phone: "Телефон",
            email: "Эл. адрес",
            showing: "Показаны",
            from: "-",
            to: "из",
            from_records: "записей",
            filters: "Фильтры",
            search: "Поиск...",
            association: "Тренинг",
            website_email: "Веб-сайт/эл-почта",
            address: "Адрес",
            rooms: "Номера",
            beds: "Кровати",
            cuisine: "Кухня",
            working: "Работает",
            car_release_year: "Год выпуска автомобиля",
            seats: "Автомобильные сиденья",
        },
        error: {
            title: "Страница не найдена",
            text: "Страница, которую вы ищете, могла быть удалена, сменила название или временно недоступна.",
            button: "Вернуться на Главную",
        },
        validation: {
            error: "Заполните все данные правильно!",
            required_field: "Обязательное поле.",
            email: "Введите правильный адрес эл-почты.",
            min5: "Минимум 5 символов.",
            min10: "Минимум 10 символов.",
            min20: "Минимум 20 символов.",
            phone: "Номер должен состоять из 9 цифр.",
            id: "Разрешено 9/11 цифр для идентификатора.",
            file_size:
                "Размер файла для этих изображений превышает наши ограничения. Вы можете загрузить не более 1 МБ на файл",
            products: "Требуется минимум 10 символов.",
        },
        tour_form: {
            name: "Полное имя",
            name_placeholder: "Пр: Георгий Беридзе",
            email: "Эл. адрес",
            email_placeholder: "Пр: giorgiberidze@gmail.com",
            phone: "Телефон",
            phone_placeholder: "Пр: 577223344",
            agency: "Название агентства",
            agency_placeholder: "Пр: Вандерленд",
            button: "Регистрация",
            success_message: "Вы успешно зарегистрировались!",
            not_allowed_message: "Лимит регистрации исчерпан!",
            already_registered: "Вы уже зарегистрированы!",
            products: "Товары для выставки",
            confirm_button: "Закрыть",
        },
        booking: {
            company_name: "Название компании",
            company_name_placeholder: "Пр: Отель Адмирал",
            company_id: "Идентификатор компании",
            company_id_placeholder: "Пр: 123456789",
            company_director: "Директор компании",
            company_director_placeholder: "Пр: Ника Болквадзе",
            contact_person: "Имя контактного лица",
            contact_person_placeholder: "Пр: Георгий Беридзе",
            success_message: "Забронировано успешно!",
        },
        good_host: {
            company_type: "Тип компании",
            choose_company_type: "Выберите тип компании",
            accommodation: "Guest house",
            food: "Restaurant",
            select_question: "Проверьте связанные",
            relevant: "Соответствующий",
            comment: "Комментарий",
            required: "Необходимый",
            recommended: "Рекомендуемые",
            add_comment: "Добавить комментарий",
            company_name: "Название компании",
            contact_person: "Контактное лицо",
            website: "Веб-сайт",
            link: "URL-адрес",
            check_minimum_one_question:
                "Пожалуйста, проверьте минимум один вопрос!",
            success_text:
                "Мы проверим вашу заявку и свяжемся с вами в ближайшее время.",
            close: "Закрыть",
            remove_comment: "Удалить комментарий",
        },
        new_record: {
            add_new_record: "Добавить новую запись",
            main_information: "Main information",
            category: "Категория",
            city_municipality: "Город/муниципалитет",
            village: "Деревня",
            title: "Название",
            contact_information: "Контактная информация",
            street: "Улица",
            address: "Адрес",
            additional_information: "Дополнительная информация",
            stars: "Звезды",
            rooms: "Номера",
            beds: "Кровати",
            check_in: "Check-in",
            check_out: "Check-out",
            price_from: "Цена (от)",
            price_to: "Цена (до)",
            services: "Услуги",
            seasons: "Времена года",
            adapted_room: "Адаптированные номера",
            quantity: "Количество",
            president_suite_room: "Президентские люксы",
            open_year: "Год открытия",
            lat: "Широта",
            long: "Долгота",
            media: "Медия",
            image: "Изображение",
            new_record: "Новая запись",
            add_message:
                "Мы получили ваш запрос. Пожалуйста, дождитесь нашего подтверждающего сообщения.",
            director: "Директор",
            director_phone: "Телефон директора",
            manager: "Менеджер",
            manager_phone: "Телефон менеджера",
            cuisines: "Кухня",
            wines: "Виды вина",
            live_music: "Живая музыка",
            lunch_menu: "Ланч меню",
            pandus: "Пандус",
            seats: "Места",
            hours_from: "Время работы (от)",
            hours_to: "Время работы (до)",
            countries: "Страны",
            full_name: "Полное имя",
            birth_year: "Год рождения",
            experience: "Опыт (год)",
            certified: "Сертифицированный",
            languages: "Языки",
            associations: "Ассоциация / обучение",
            registration: "Регистрация",
            your_status: "Ваш статус",
            physical_person: "Физическое лицо",
            juridical_person: "Юридическое лицо",
        },
        url_shortener: {
            shorten: "Сократить",
            copied: "Скопировано",
            copy: "Копировать",
        },
        qr_generator: {
            generate: "Генерировать",
            download: "Скачать",
        },
        hiking_festival: {
            birthday: "Birthday (Day/Month/Year)",
            country: "Country",
            city: "City",
            passport: "Passport or ID (Both sides, Max. 5MB)",
            where_did_you_find_us: "How did you learn about this event?",
            about: "About you",
            gets_medicaments: "Do you take any medications?",
            registration_success:
                "You have been registered successfully. We will get back to you soon.",
            yes: "Yes",
            no: "No",
            file_size_limit: "File size too big.",
            has_hiking_experience:
                "Do you have hiking experience in the mountains?",
            has_hiking_equipments:
                "Do you have all the necessary equipment for hiking?",
            is_with_partner:
                "Do you plan to participate in this festival with your partner?",
            partner_name: "Partner's full name",
            distance_while_hiking:
                "How many kilometers have you walked while hiking in the mountains?",
            choose: "Choose one",
            friend: "Friend told me",
            social: "Facebook or other social network",
            google: "Google or other search engine",
            other: "Other",
            current_city: "Temporary or permanent place of residence (City)",
        },
    },
};

export default translations;
